// 登录跳转的单一真相来源：redirect 取值校验 + 构造 /login URL，守卫 / 登录页 / 全局 401 共用。

// 读 ?redirect，仅接受站内相对路径（'/' 开头且非 '//' 协议相对），否则回落 '/'
export const resolveReturnTo = (search: string): string => {
  const redirect = new URLSearchParams(search).get('redirect')
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
    return redirect
  }
  return '/'
}

// 构造 /login?redirect=<编码当前路径>，入参为 pathname + search
export const buildLoginUrl = (pathWithSearch: string): string => `/login?redirect=${encodeURIComponent(pathWithSearch)}`

// hash router 下服务端 302 无法感知 hash 内路由，用 sessionStorage 暂存 returnTo，
// ticket exchange 成功后恢复。
const AUTH_RETURN_TO_KEY = 'auth_return_to'

export const stashReturnTo = (path: string): void => {
  try {
    sessionStorage.setItem(AUTH_RETURN_TO_KEY, path)
  } catch {
    /* SSR / 无存储 */
  }
}

export const popReturnTo = (): string | null => {
  try {
    const v = sessionStorage.getItem(AUTH_RETURN_TO_KEY)
    if (v) sessionStorage.removeItem(AUTH_RETURN_TO_KEY)
    return v
  } catch {
    return null
  }
}
